import { onBeforeUnmount, shallowRef, watch, type Ref } from "vue";

export const useImageUploadPreviews = (files: Ref<(File | CustomFile)[]>) => {
  const previews = shallowRef<{ id: string; file: File | CustomFile; url: string }[]>([]);
  watch(() => [...files.value], selected => {
    const previous = new Map<File | CustomFile, typeof previews.value>();
    previews.value.forEach(preview => {
      const entries = previous.get(preview.file) ?? [];
      entries.push(preview);
      previous.set(preview.file, entries);
    });
    previews.value = selected.map(file => {
      const existing = previous.get(file)?.shift();
      if (existing) return existing;
      const blob = file instanceof Blob ? file : new Blob([file.data as BlobPart], { type: file.type });
      return { id: crypto.randomUUID(), file, url: URL.createObjectURL(blob) };
    });
    previous.forEach(entries => entries.forEach(preview => URL.revokeObjectURL(preview.url)));
  }, { immediate: true });
  onBeforeUnmount(() => previews.value.forEach(preview => URL.revokeObjectURL(preview.url)));
  return previews;
};
